export default __webpack_public_path__ + "static/media/EM0220.34I-21898_-25387_0.61e7cbb8.jpg";